/**
 * HUB-C — Timeline paiements unifiée (SumUp + Stripe).
 */
import React from 'react';
import { Clock } from 'lucide-react';
import ActivitePaiementCard from './ActivitePaiementCard';
import ActiviteStripePaiementCard from './ActiviteStripePaiementCard';
import { formatPaymentDate } from '../../utils/paiements/paiementsDisplay';

export default function ActivitePaiementsTimeline({
  events,
  actions,
  confirming,
  cancelling,
  loading,
  testIdPrefix = 'activite-paiements',
}) {
  if (loading) {
    return (
      <div className="flex justify-center py-12" data-testid={`${testIdPrefix}-timeline-loading`}>
        <div className="loading-spinner" />
      </div>
    );
  }

  if (!events?.length) {
    return (
      <div
        className="text-center py-12 text-[var(--rm-gray-500)]"
        data-testid={`${testIdPrefix}-timeline-empty`}
      >
        <Clock className="w-12 h-12 mx-auto mb-3 opacity-40" />
        <p>Aucun paiement pour cette période</p>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid={`${testIdPrefix}-timeline`}>
      {events.map((event) => (
        <div key={event.id} className="relative pl-4 border-l-2" style={{ borderColor: 'var(--rm-border-subtle)' }}>
          <div className="absolute -left-[5px] top-4 w-2 h-2 rounded-full bg-[var(--rm-gray-400)]" />
          <p className="text-xs text-[var(--rm-gray-500)] mb-2 pl-1" data-testid={`${testIdPrefix}-timeline-date-${event.id}`}>
            {formatPaymentDate(event.date)}
          </p>
          {event.source === 'sumup' ? (
            <ActivitePaiementCard
              payment={event.payment}
              actions={actions}
              confirming={confirming}
              cancelling={cancelling}
              testIdPrefix={testIdPrefix}
              compact
            />
          ) : (
            <ActiviteStripePaiementCard
              payment={event.payment}
              testIdPrefix={testIdPrefix}
              compact
            />
          )}
        </div>
      ))}
    </div>
  );
}
